import ElementPlus from 'element-plus'
import { createI18n } from 'vue-i18n'
import 'element-plus/dist/index.css'
import localeZH from 'element-plus/es/locale/lang/zh-cn'
import localeEN from 'element-plus/es/locale/lang/en'
import messages from '../utils/i18n'

const i18n = createI18n({
	locale: localeZH.name,
	fallbackLocale: localeEN.name,
	messages,
})

/**
 * Element Plus 全局补丁：el-image 点击放大时，自动把 viewer wrapper 移到 <body>。
 * 原因：EP 默认把 viewer 渲染在 el-image 组件 DOM 内部（非 teleport），
 * 而 el-table 等有 overflow:hidden 的容器会把全屏遮罩裁掉，导致点击后看不到任何东西。
 * 这个补丁一次性解决全站所有 el-image 预览失效的问题。
 */
function patchElImageViewerTeleport() {
	const MOVE_TO_BODY = () => {
		const wrapper = document.querySelector('.el-image-viewer__wrapper');
		if (wrapper && wrapper.parentElement !== document.body) {
			document.body.appendChild(wrapper);
		}
	};
	// 监听 body 的子树变化：一旦出现 viewer wrapper 就立刻移动
	const observer = new MutationObserver(() => MOVE_TO_BODY());
	observer.observe(document.documentElement, { childList: true, subtree: true });
	// 防御性定时兜底
	setInterval(MOVE_TO_BODY, 200);
}

export default (app) => {
	app.use(ElementPlus, { locale: localeZH })
	app.use(i18n)
	// 等 DOM 准备好再启动补丁
	if (typeof window !== 'undefined') {
		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', patchElImageViewerTeleport);
		} else {
			patchElImageViewerTeleport();
		}
	}
}
